import React, { useState, useEffect } from 'react'

import Chapter1 from '../RiseOfShowChoir/Chapter1';
import Chapter2 from '../RiseOfShowChoir/Chapter2';
import Chapter3 from '../RiseOfShowChoir/Chapter3';
import Chapter4 from '../RiseOfShowChoir/Chapter4';
import Chapter5 from '../RiseOfShowChoir/Chapter5';
import Chapter6 from '../RiseOfShowChoir/Chapter6';
import Chapter7 from '../RiseOfShowChoir/Chapter7';
import Chapter8 from '../RiseOfShowChoir/Chapter8';
import Chapter9 from '../RiseOfShowChoir/Chapter9';
import Chapter10 from '../RiseOfShowChoir/Chapter10';
import Chapter11 from '../RiseOfShowChoir/Chapter11';

import "../styles/article.css";

const RiseOfShowChoir = () => {

    const [currentChapterHistory, setCurrentChapterHistory] = useState(() => {
        const savedChapter = localStorage.getItem("currentChapterHistory");
        return savedChapter ? JSON.parse(savedChapter) : 0;
    });

    useEffect(() => {
        localStorage.setItem("currentChapterHistory", JSON.stringify(currentChapterHistory));
    }, [currentChapterHistory]);

    useEffect(() => {
        // Scroll to the top of the page whenever the chapter changes
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Adds a smooth scrolling effect
        });
    }, [currentChapterHistory]);

    const nextChapter = () => {
        setCurrentChapterHistory((prevChapter) => Math.min(prevChapter + 1, 11));
    };

    const prevChapter = () => {
        setCurrentChapterHistory((prevChapter) => Math.max(prevChapter - 1, 0));
    };



    return (
        <>
            {currentChapterHistory === 0 ? (
                <div className="title-screen">
                    <div
                        id="history-title"
                        style={{ backgroundImage: `url('images/history/history-cover.jpg')` }}
                    >
                        <h1>Spotlight and Sound: </h1>
                        <h2>The Rise of Show Choir in America</h2>

                        <button onClick={nextChapter} className="echo-bgn">
                            Begin Reading
                        </button>
                    </div>
                </div>
            ) : (
                <div className="card">
                    <div className="Home__container">
                        <div className="article-border">
                            <div className="article-container">
                                <div className="article-chapter-control">
                                    <span className="chapter-lbl">
                                        Chapter {currentChapterHistory} / 11
                                    </span>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                        }}
                                    >
                                        <button
                                            className="chapter-btn"
                                            onClick={prevChapter}
                                        >
                                            <img src="images/arrow-left.png" alt="Previous" />
                                        </button>
                                        <button
                                            className="chapter-btn"
                                            onClick={nextChapter}
                                        >
                                            <img src="images/arrow-right.png" alt="Next" />
                                        </button>
                                    </div>
                                </div>
                                <div className="echoes-border">
                                    {currentChapterHistory === 1 ? (
                                        <Chapter1 />
                                    ) : currentChapterHistory === 2 ? (
                                        <Chapter2 />
                                    ) : currentChapterHistory === 3 ? (
                                        <Chapter3 />
                                    ) : currentChapterHistory === 4 ? (
                                        <Chapter4 />
                                    ) : currentChapterHistory === 5 ? (
                                        <Chapter5 />
                                    ) : currentChapterHistory === 6 ? (
                                        <Chapter6 />
                                    ) : currentChapterHistory === 7 ? (
                                        <Chapter7 />
                                    ) : currentChapterHistory === 8 ? (
                                        <Chapter8 />
                                    ) : currentChapterHistory === 9 ? (
                                        <Chapter9 />
                                    ) : currentChapterHistory === 10 ? (
                                        <Chapter10 />
                                    ) : currentChapterHistory === 11 ? (
                                        <Chapter11 />
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="article-chapter-control">
                                    <span className="chapter-lbl">
                                        Chapter {currentChapterHistory} / 11
                                    </span>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                        }}
                                    >
                                        <button
                                            className="chapter-btn"
                                            onClick={prevChapter}
                                        >
                                            <img src="images/arrow-left.png" alt="Previous" />
                                        </button>
                                        <button
                                            className="chapter-btn"
                                            onClick={nextChapter}
                                        >
                                            <img src="images/arrow-right.png" alt="Next" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className='article-ad'>
                                {currentChapterHistory === 1 || currentChapterHistory === 7 ? (
                                    <a href='https://www.accoladi.com/' target='_blank'>
                                        <img src='images/history/accoladi.jpg' />
                                    </a>
                                ) : currentChapterHistory === 2 ? (
                                    <a href='https://www.accoladi.com/' target='_blank'>
                                        <img src='images/history/accoladi-2.jpg' />
                                    </a>

                                ) : currentChapterHistory === 3 || currentChapterHistory === 8 ? (
                                    <a href='https://www.accoladi.com/' target='_blank'>
                                        <img src='images/history/accoladi-3.jpg' />
                                    </a>

                                ) : currentChapterHistory === 4 || currentChapterHistory === 9 ? (
                                    <a href='https://www.accoladi.com/' target='_blank'>
                                        <img src='images/history/accoladi-4.jpg' />
                                    </a>
                                ) : currentChapterHistory === 5 || currentChapterHistory === 10 ? (
                                    <a href='https://www.accoladi.com/' target='_blank'>
                                        <img src='images/history/accoladi-5.jpg' />
                                    </a>
                                ) : currentChapterHistory === 6 || currentChapterHistory === 11 ? (
                                    <a href='https://www.accoladi.com/' target='_blank'>
                                        <img src='images/history/accoladi-6.jpg' />
                                    </a>
                                ) : (
                                    <></>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default RiseOfShowChoir